/**
 * Navigation Preferences Types
 *
 * Types for personalized workspace navigation (favorites, hidden, sort order).
 * Stored in users.workspace_favorites JSONB column.
 */

/**
 * User's navigation preferences stored in DB
 */
export interface NavigationPreferences {
  /** Tool IDs marked as favorites (shown at top) */
  favorites: string[];
  /** Tool IDs hidden from sidebar (only in "Alle Tools" modal) */
  hidden: string[];
  /** Custom sort order for non-favorite tools (tool_id -> position) */
  sortOrder: Record<string, number>;
  /** Schema version for migrations */
  version: number;
}

/**
 * Default preferences for new users
 */
export const DEFAULT_NAVIGATION_PREFERENCES: NavigationPreferences = {
  favorites: [],
  hidden: [],
  sortOrder: {},
  version: 1,
};

/**
 * API response for GET /api/v1/navigation/preferences
 */
export interface NavigationPreferencesResponse {
  preferences: NavigationPreferences;
}

/**
 * API request for PUT /api/v1/navigation/preferences
 */
export interface UpdateNavigationPreferencesRequest {
  preferences: NavigationPreferences;
}

/**
 * API request for PATCH /api/v1/navigation/preferences/favorite
 */
export interface ToggleFavoriteRequest {
  toolId: string;
  isFavorite: boolean;
}

/**
 * API request for PATCH /api/v1/navigation/preferences/visibility
 */
export interface ToggleVisibilityRequest {
  toolId: string;
  isHidden: boolean;
}

/**
 * API request for PATCH /api/v1/navigation/preferences/sort
 */
export interface UpdateSortOrderRequest {
  sortOrder: Record<string, number>;
}
